import React from "react";
import LegalLayout from "@/components/LegalLayout/LegalLayout";
import { CONTACTS } from "@/constants/contacts";

export default function TermosPage() {
  return (
    <LegalLayout title="Termos de Uso" testId="termos-page">
      <p className="legal-intro">
        Estes Termos regem o uso do Akali AI por profissionais habilitados.
        Leia com atenção antes de utilizar o sistema.
      </p>

      <div className="legal-section">
        <h2>1. Objeto</h2>
        <p>
          O Akali AI, produto operado por{" "}
          <strong>Fisiopilates Barra Mansa Ltda</strong> (CNPJ
          49.797.203/0001-40), oferece licença de uso de software de apoio à
          documentação clínica para fisioterapeutas habilitados pelo CREFITO.
        </p>
      </div>

      <div className="legal-section">
        <h2>2. Aceitação</h2>
        <p>O uso do sistema implica aceitação integral destes Termos.</p>
        <ul>
          <li>Uso por menores de 18 anos não é permitido.</li>
          <li>
            Uso por profissionais não habilitados pelo CREFITO não é permitido.
          </li>
        </ul>
      </div>

      <div className="legal-section">
        <h2>3. Obrigações do usuário</h2>
        <ul>
          <li>Manter credenciais de acesso confidenciais.</li>
          <li>
            Revisar obrigatoriamente todo prontuário gerado antes de aprovar.
          </li>
          <li>
            Não aprovar prontuários sem leitura e validação clínica.
          </li>
          <li>Usar o sistema em conformidade com as normas do COFFITO.</li>
          <li>
            Não utilizar o sistema para fins distintos da documentação clínica
            própria.
          </li>
        </ul>
      </div>

      <div className="legal-section">
        <h2>4. Limitação de responsabilidade</h2>
        <div className="legal-callout" data-testid="termos-liability-callout">
          <p>
            O Akali AI é uma ferramenta de apoio à documentação clínica. A
            responsabilidade pelo conteúdo clínico, pela precisão diagnóstica e
            pela conformidade regulatória do prontuário final é{" "}
            <strong>
              exclusivamente do profissional habilitado que o revisou e aprovou
            </strong>
            . A Fisiopilates Barra Mansa Ltda não se responsabiliza por
            decisões clínicas baseadas em outputs não revisados pelo
            profissional.
          </p>
        </div>
      </div>

      <div className="legal-section">
        <h2>5. Planos e pagamento</h2>
        <p>Planos conforme pricing vigente em {CONTACTS.website}.</p>
        <ul>
          <li>Renovação automática.</li>
          <li>Cancelamento a qualquer momento sem multa.</li>
          <li>Reembolso proporcional não disponível para períodos parciais.</li>
          <li>
            Preços em Reais (BRL), sujeitos a reajuste com aviso prévio de 30
            dias.
          </li>
        </ul>
      </div>

      <div className="legal-section">
        <h2>6. Propriedade intelectual</h2>
        <p>
          O software, modelos, interfaces e documentação são propriedade
          exclusiva da Fisiopilates Barra Mansa Ltda. É vedada reprodução,
          engenharia reversa ou distribuição sem autorização expressa.
        </p>
        <p>
          Os prontuários gerados e aprovados pelo profissional são de
          propriedade do profissional e/ou da clínica contratante.
        </p>
      </div>

      <div className="legal-section">
        <h2>7. Suspensão e cancelamento</h2>
        <p>
          A Akali AI reserva-se o direito de suspender contas em caso de uso em
          violação a estes Termos, com notificação prévia por e-mail sempre que
          possível.
        </p>
        <p>
          Para dúvidas ou comunicações relativas a estes Termos, entre em
          contato pelo e-mail{" "}
          <a
            href={`mailto:${CONTACTS.general}`}
            className="legal-mail"
            data-testid="termos-contact-email"
          >
            {CONTACTS.general}
          </a>
          .
        </p>
      </div>

      <div className="legal-section">
        <h2>8. Foro</h2>
        <p>
          Fica eleito o foro da <strong>Comarca de Barra Mansa, Estado do Rio
          de Janeiro</strong>, para dirimir quaisquer controvérsias decorrentes
          destes Termos, com renúncia a qualquer outro, por mais privilegiado
          que seja.
        </p>
      </div>
    </LegalLayout>
  );
}
